import { trackEvent } from "@leafly-com/web-utils";
import Link from "next/link";

import Image from "components/Image";
import TrackImpression from "components/TrackImpression";

type Props = {
  link: string;
  title: string;
  image?: string;
  eventCategory?: string;
};

const Tile = ({ link, title, image, eventCategory }: Props) =>
  link && title && image ? (
    <TrackImpression
      category={eventCategory}
      label={title}
      className="col md:col-1/2 mb-md"
      style={{ height: 130 }}
    >
      <Link
        href={link}
        className="block h-full w-full relative carousel-card--gradient rounded shadow-low overflow-hidden"
        onClick={() => {
          eventCategory && trackEvent(eventCategory, "Click", title);
        }}
      >
        {title && (
          <div className="text-white absolute p-lg bottom-0 z-10">
            <h3 className="font-normal text-sm">{title}</h3>
          </div>
        )}
        {image && (
          <Image
            src={image}
            sizes={[300]}
            background
            alt={""}
            backgroundPosition="center right"
          />
        )}
      </Link>
    </TrackImpression>
  ) : null;

export default Tile;
